module.exports = __webpack_public_path__ + "img/anime3.bd6820f1.png";